import { render, staticRenderFns } from "./error-popup.vue?vue&type=template&id=427d99da&scoped=true&"
import script from "./error-popup.vue?vue&type=script&lang=js&"
export * from "./error-popup.vue?vue&type=script&lang=js&"
import style0 from "./error-popup.vue?vue&type=style&index=0&id=427d99da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d99da",
  null
  
)

export default component.exports